class UserService {
  static getFullName(dto: { first_name: string; last_name: string }) {
    return [dto.first_name, dto.last_name].join(' ')
  }
}

export { UserService }
